module.exports = function() {
  return new Worker(__webpack_public_path__ + "1bc5123c6222076b8848.worker.js");
};